

 const API_URL = "https://vrbuilders.globalbuzz.in/ajaxapi/";

//const API_URL = "http://localhost:8080/xampp/apoorva/vrbuilders/ajaxapi/";

export default API_URL;